import { render, staticRenderFns } from "./FilterList.vue?vue&type=template&id=5b8340de&scoped=true&"
import script from "./FilterList.vue?vue&type=script&lang=js&"
export * from "./FilterList.vue?vue&type=script&lang=js&"
import style0 from "./FilterList.vue?vue&type=style&index=0&id=5b8340de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8340de",
  null
  
)

component.options.__file = "FilterList.vue"
export default component.exports